export class PayerConfigFilterValues {
    Payer: string;
    Status: string;
    RiskAdjustmentPolicy: string;
    OmitPayer: string;
    PreferredActionSubmissionType: string;
    PolicyServiceYearStart: string;
    PolicyServiceYearEnd: string;
}
